import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AppointmentTypeRoomTypesForm } from "@/components/appointment/type/appointment-type-room-types-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetAppointmentTypeRoomTypesQuery = graphql(`
  query GetAppointmentTypeEditRoomTypesQuery {
    ...AppointmentTypeRoomTypesQueryFragment
  }
`);

const AppointmentTypeRoomTypesPage = (): JSX.Element => {
  const params = Route.useParams();
  const queryResult = useGraphQL(GetAppointmentTypeRoomTypesQuery);
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Tipo de sala" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentTypeRoomTypesForm
              data={data}
              appointmentTypeId={params.appointmentTypeId}
            />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type",
)({
  parseParams: (params) => ({
    appointmentTypeId: z.int().parse(Number(params.appointmentTypeId)),
  }),
  component: AppointmentTypeRoomTypesPage,
});
